import './js/common.js';
import './js/fullscreenpanel.js';
import './js/searchpanel.js';
import './js/searchform.js';
import './js/multilevelmenu.js';
import './js/scrollanimations.js';
import './sass/style.scss';

( function( $ ) {
	$(document).ready(function(){
		console.log("@@@Idrogeno@@@");
	});
} )( jQuery );